
import { defineComponent, ref } from 'vue';
import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import TipoOperacaoModal from './TipoOperacaoModal.vue';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import ServicoTipoOperacao from '@/servicos/Cadastros/ServicoTipoOperacao';

export default defineComponent({
  name: 'TipoOperacao',
  components: {
    TelaPadraoCrud,
    TipoOperacaoModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoTipoOperacao = new ServicoTipoOperacao();
    const refCrud = ref<InstanceType<typeof TelaPadraoCrud>>();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = true;
    crudBase.estrutura.verificarCadastroCompartilhado = true;
    crudBase.estrutura.botaoPrincipalAcao = 'Novo';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão do tipo de operação?';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 1, visible: false, ordering: true,
      },
      {
        title: 'Descrição', dataIndex: 'descricao', key: 'Descricao', position: 2, visible: true, ordering: true, customRenderRow: ECustomRenderRow.LinkAcao, width: 300,
      },
      {
        title: 'Forma de Pagamento', dataIndex: 'descricaoFormaPagamento', key: 'FormaPagamento', position: 3, visible: true, align: 'left', width: 200,
      },
      {
        title: 'Cenário Fiscal', dataIndex: 'nomeCenarioFiscal', key: 'CenarioFiscal', position: 3, visible: true, align: 'left', width: 200,
      },
      {
        title: 'Mov. Estoque', dataIndex: 'movimentarEstoque', key: 'MovimentarEstoque', position: 4, visible: true, align: 'center', fixed: 'center', width: 100, customRenderRow: ECustomRenderRow.TagSimNao,
      },
      {
        title: 'Ações', key: 'acoes', position: 5, visible: true, fixed: 'right', width: 70, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade.push({ identificador: 'Codigo', ordem: 'DESC' } as IOrdenacao);

    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrud.value !== undefined) {
        await refCrud.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }

    return {
      crudBase,
      servicoTipoOperacao,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
      refCrud,
    };
  },
});
